import { render, staticRenderFns } from "./authac.vue?vue&type=template&id=0404d463&scoped=true"
import script from "./authac.vue?vue&type=script&lang=js"
export * from "./authac.vue?vue&type=script&lang=js"
import style0 from "./authac.vue?vue&type=style&index=0&id=0404d463&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0404d463",
  null
  
)

export default component.exports